module.exports = __webpack_public_path__ + "img/magazine31.ef54af41.jpg";